import RemoveIcon from '@mui/icons-material/Remove';
import { Checkbox as MuiCheckbox, FormControlLabel, Grid, IconButton, Popover } from '@mui/material';
import Box from '@mui/material/Box';
import { useFormikContext } from 'formik';
import * as React from 'react';
import { memo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { AirportConfigurationType } from '../../../backend';
import { StyledFormGroup } from '../../form/Checkbox/Checkbox.style';
import { ConfigurationsPageFormValues } from '../../pages/ConfigurationPage';
import {
    StyledMenuIcon,
    StyledPropertiesGrid,
} from '../../Resources/ResourceContent/ResourceFields/Properties/PropertiesMenu.style';
import { getPropertiesListByType } from './ConfigurationPropertiesMenu.utils';
import { MultiConfigurationsForm } from './MultiConfigurationsForm';

export const ConfigurationPropertiesMenu = memo(function ConfigurationPropertiesMenu({
    configurationType,
    selectedConfigurations,
    setSelectedConfigurations,
    arrayRemove,
}: {
    configurationType: AirportConfigurationType;
    selectedConfigurations: number[];
    setSelectedConfigurations: (e: number[]) => void;
    arrayRemove: (index: number) => void;
}) {
    const { values } = useFormikContext<ConfigurationsPageFormValues>();

    const handleChange = useCallback(
        event => {
            if (event.target.checked) {
                setSelectedConfigurations(
                    values.configurations.filter(c => !c.defaultConfig).map(r => values.configurations.indexOf(r)),
                );
            } else {
                setSelectedConfigurations([]);
            }
        },
        [setSelectedConfigurations, values.configurations],
    );

    const [anchorEl, setAnchorEl] = React.useState<HTMLLabelElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLLabelElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <StyledPropertiesGrid container>
            <Grid item width={'40px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <StyledFormGroup>
                    <FormControlLabel
                        control={<MuiCheckbox icon={<span />} checkedIcon={<RemoveIcon />} />}
                        label={''}
                        checked={selectedConfigurations.length !== 0}
                        onChange={handleChange}
                    />
                </StyledFormGroup>
            </Grid>
            {getPropertiesListByType(configurationType).map((property, index) => (
                <Grid
                    item
                    key={index}
                    color={'white'}
                    xs
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <Box sx={{ textAlign: 'center' }}>
                        <FormattedMessage id={`Configuration.${property}`} />
                    </Box>
                </Grid>
            ))}
            <Grid
                item
                width={'60px'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                marginRight={'10px'}
            >
                <IconButton
                    aria-describedby={id}
                    aria-label="delete"
                    component="label"
                    onClick={handleClick}
                    disabled={selectedConfigurations.length === 0}
                >
                    <StyledMenuIcon />
                </IconButton>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <MultiConfigurationsForm
                        selectedConfigurations={selectedConfigurations}
                        setSelectedConfigurations={setSelectedConfigurations}
                        arrayRemove={arrayRemove}
                        setAnchorEl={setAnchorEl}
                        configurationType={configurationType}
                    />
                </Popover>
            </Grid>
        </StyledPropertiesGrid>
    );
});
